import { useState } from 'react';

import type { RowTransition } from './use-waiting-for-you';

const withoutId = (ids: ReadonlySet<string>, itemId: string) =>
  ids.has(itemId) ? new Set([...ids].filter((id) => id !== itemId)) : ids;

// Rows the user ran stay listed (retained) until their exit ends. Rows the
// user dismissed are departed once their exit ends, and return on Undo.
export const useRowTransitions = (onRowLeft: (itemId: string) => void) => {
  const [retainedCardIds, setRetainedCardIds] = useState<ReadonlySet<string>>(
    () => new Set()
  );
  const [departedCardIds, setDepartedCardIds] = useState<ReadonlySet<string>>(
    () => new Set()
  );
  const [historyArrivals, setHistoryArrivals] = useState(0);

  const retainCards = (cardIds: readonly string[]) =>
    setRetainedCardIds((current) => new Set([...current, ...cardIds]));

  const endTransition = (itemId: string, transition: RowTransition) => {
    if (transition === 'returning') {
      setDepartedCardIds((current) => withoutId(current, itemId));
      return;
    }
    if (transition === 'completing')
      setRetainedCardIds((current) => withoutId(current, itemId));
    else setDepartedCardIds((current) => new Set(current).add(itemId));
    onRowLeft(itemId);
    setHistoryArrivals((count) => count + 1);
  };

  return {
    retainedCardIds,
    departedCardIds,
    historyArrivals,
    retainCards,
    endTransition,
  };
};
